import React from 'react';

import { FormattedMessage } from 'react-intl';

import LinkButton from '@atlaskit/button/link';
import { JiraIcon } from '@atlaskit/logo';
import { Inline } from '@atlaskit/primitives/compiled';

import { messages } from './messages';

export const ViewAllButton = (props: {
	totalIssuesCount?: number;
	url: string;
	callback: (e?: React.MouseEvent) => void;
	spacing?: 'compact' | 'default';
}): React.JSX.Element => {
	const { totalIssuesCount, url, callback, spacing = 'default' } = props;

	return (
		<LinkButton
			href={url}
			appearance="default"
			onClick={callback}
			onAuxClick={callback}
			onContextMenu={callback}
			testId="view-all-button"
			spacing={spacing}
		>
			<Inline space="space.075" alignBlock="center" alignInline="center">
				<JiraIcon appearance="brand" size="xxsmall" />
				{totalIssuesCount !== undefined ? (
					<FormattedMessage {...messages.viewAll} values={{ totalCount: totalIssuesCount }} />
				) : (
					<FormattedMessage {...messages.viewAllNoCount} />
				)}
			</Inline>
		</LinkButton>
	);
};
